import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-092f815e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-checked", "onKeydown"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "toggle-btn",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["switch-container", { on: $setup.isOn }]),
    role: "switch",
    "aria-checked": $setup.isOn,
    onClick: $setup.toggleSwitch,
    onKeydown: _withKeys(_withModifiers($setup.toggleSwitch, ["prevent"]), ["enter"])
  }, [..._hoisted_3], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_1))
}